import { useContext } from 'react';
import { OrderbookDisplayContext } from '../../providers/orderbookDisplayProvider';
import OrderbookDisplay from './OrderbookDisplay';

const Orderbook = () => {
	const displayProps = useContext(OrderbookDisplayContext);

	return <OrderbookDisplay {...displayProps} />;
};

export default Orderbook;
